export const tileCountY = 10;

export const animationDuration = 250;

export const boardMargin = 10;